export default __webpack_public_path__ + "static/media/event-3.53608bb5.png";